const m = window.require("discourse/helpers/dir-span");
if (m.default && !m.__esModule) {
  m.__esModule = true;
}
module.exports = m;